import PropTypes from "prop-types";

// material-ui
import { useTheme } from "@mui/material/styles";
import { AppBar, Toolbar, useMediaQuery } from "@mui/material";

// project import
import AppBarStyled from "./AppBarStyled";
import HeaderContent from "./HeaderContent";


// ==============================|| MAIN LAYOUT - HEADER ||============================== //

const Header = ({ open, showBanner }) => {
    const theme = useTheme();
    const matchDownMD = useMediaQuery(theme.breakpoints.down("md"));

    // common header
    const mainHeader = (
        <Toolbar>
            <HeaderContent drawerOpen={open} />
        </Toolbar>
    );

    // app-bar params
    const appBar = {
        position: "sticky",
        color: "inherit",
        elevation: 0,
        sx: {
            pt: 0,
            pd: 0,
            bgcolor: 'transparent',
            top: showBanner ? 'var(--banner-height, 0px)' : 0,
            transition: 'top 0.3s ease'
        },
    };

    return (
        <>
            {!matchDownMD ? (
                <AppBarStyled open={open} {...appBar}>
                    {mainHeader}
                </AppBarStyled>
            ) : (
                <AppBar {...appBar}>
                    {mainHeader}
                </AppBar>
            )}
        </>
    );
};

Header.propTypes = {
    open: PropTypes.bool,
    handleDrawerToggle: PropTypes.func,
    showBanner: PropTypes.bool
};

export default Header;
